import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Effectenrekeningen"
      maxWidth={1000}
      description="Bent u titularis van één of meerdere effectenrekeningen"
    >
      <Grid container spacing={2}>
        <RadioGroupInput
          name="securities_accounts"
          items={[
            { text: 'ja - meer dan 1', value: 'ja_meer_dan_1' },
            {
              text: 'Neen - slechts 1 of geen effectenrekening',
              value: 'nee_max_1',
            },
          ]}
          xs={12}
          row={false}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
